import _ from "lodash";

export const deepOmitTypename = (obj: any): any => {
  const without = _.omit(obj, "__typename");
  return _.mapValues(without, val => {
    return _.isObject(val) ? deepOmitTypename(val) : val;
  });
};

export const deepDifference = (obj: any, base: any): any => {
  const changes = (obj: any, base: any): any => {
    return _.transform(obj, function(result, value, key) {
      if (!_.isEqual(value, base[key])) {
        result[key] =
          _.isObject(value) && _.isObject(base[key])
            ? changes(value, base[key])
            : value;
      }
    });
  };
  return changes(obj, base);
};

/**
 *
 * @param object any object
 * @returns an iterable array of the object's keys
 */
export function keyIter<T extends object>(object: T): (keyof T)[] {
  return Object.keys(object) as (keyof T)[];
}
